import React, { useState } from 'react';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { Fab } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

import useGlobalSearch from './useGlobalSearch';
import SearchDialog from './SearchDialog';

import logger from 'itrvl-logger';

const log = logger(__filename);
log.trace(__filename);

export default function GlobalSearch() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [open, setOpen] = useState(false);

  const { searchTerm, results, filteredResults, hasResults, isLoading, isError, handleSearchChange, handleCancel, handleLinkClick, limit } =
    useGlobalSearch();

  const handleOpen = () => setOpen(true);

  const handleClose = () => setOpen(false);

  const searchButton = (
    <Fab aria-label="search" size="small" onClick={handleOpen} sx={{ '&:hover': { backgroundColor: 'grey.400' }, flexShrink: 0 }}>
      <SearchIcon />
    </Fab>
  );

  return (
    <>
      {searchButton}
      <SearchDialog
        open={open}
        fullScreen={isMobile}
        onClose={handleClose}
        searchTerm={searchTerm}
        results={results}
        filteredResults={filteredResults}
        hasResults={hasResults}
        isLoading={isLoading}
        isError={isError}
        onChange={handleSearchChange}
        onCancel={handleCancel}
        onLinkClick={handleLinkClick}
        limit={limit}
      />
    </>
  );
}
